import React from 'react';
import { styles } from './Quote.css';

export type QuoteProps = {
  children: React.ReactNode;
};

export const Quote: React.FC<QuoteProps> = ({ children }) => {
  return (
    <blockquote className={styles.quote}>
      <span role="presentation" aria-label="quote" className={styles.quoteIcon}>
        “
      </span>
      {children}
    </blockquote>
  );
};
